import React from "react";
import ModalV2 from "@/components/portal/ModalV2";
import {BlueButton, RedButton} from "@/components/ui/Buttons";
import {ButtonV2} from "@/components/ui/ButtonsV2/ButtonV2";

type ConfirmationModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    confirmButtonColor?: "red" | "green" | "blue" | "orange" | "gray";
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    open,
    setOpen,
    title,
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    onConfirm,
    confirmButtonColor = "green"
}) => {
    const handleConfirm = () => {
        onConfirm();
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <ModalV2 open={open} setOpen={setOpen}>
            <div className="">
                <h2 className="text-xl font-semibold mb-4">{title}</h2>
                <p className="text-gray-700 mb-6">{message}</p>
                <div className="grid grid-cols-2 gap-8">
                    <ButtonV2 label={cancelLabel} color="gray" onClick={handleCancel} />
                    <ButtonV2 label={confirmLabel} color={confirmButtonColor} onClick={handleConfirm} />
                </div>
            </div>
        </ModalV2>
    );
};
